import { HttpStatus, type HttpStatusCode, type UpperSnakeCase } from '../../lib/entry.js';
import { type ErrorCode, PoolbettingError } from './PoolbettingError.js';

/**
 * Error instance representing when a user isn't authorized.
 * HTTP 403
 */
export class AuthorizationError<TCode extends string = ErrorCode> extends PoolbettingError<TCode | 'UNAUTHORIZED'> {
  protected override httpStatus: HttpStatusCode = HttpStatus.Forbidden;

  constructor(
    message = 'Authorization error',
    options?: ErrorOptions,
    code: (TCode & UpperSnakeCase<TCode>) | 'UNAUTHORIZED' = 'UNAUTHORIZED'
  ) {
    super(message, options, code);
    this.name = 'AuthorizationError';
  }
}
